module.exports = __webpack_public_path__ + "static/media/raffle-logo-desktop.bfe94d40.png";